export enum StatusSeverityKey {
  DEFAULT = 'DEFAULT',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
  DANGER = 'DANGER',
  INFO = 'INFO',
}

export type TStatusSeverity =
  | 'default'
  | 'warning'
  | 'success'
  | 'danger'
  | 'info';

export const STATUS_SEVERITY: Record<StatusSeverityKey, TStatusSeverity> = {
  [StatusSeverityKey.DANGER]: 'danger',
  [StatusSeverityKey.DEFAULT]: 'default',
  [StatusSeverityKey.INFO]: 'info',
  [StatusSeverityKey.SUCCESS]: 'success',
  [StatusSeverityKey.WARNING]: 'warning',
};

export const SEVERITY_RANK: Record<StatusSeverityKey, number> = {
  [StatusSeverityKey.SUCCESS]: 1,
  [StatusSeverityKey.DEFAULT]: 2,
  [StatusSeverityKey.INFO]: 3,
  [StatusSeverityKey.WARNING]: 4,
  [StatusSeverityKey.DANGER]: 5,
};
